/**
 * Costruttori dei risultati dei tool WebMCP.
 *
 * Molti client WebMCP passano al modello solo i blocchi `content` testuali e
 * ignorano `structuredContent`: se i dati stanno solo li`, il modello vede un
 * riassunto ("Trovate 12 news") senza l'elenco e ripete la stessa chiamata per
 * ottenerlo (il client la segnala come "Duplicate tool-call loop"). Come
 * raccomandato dalla spec MCP, i dati strutturati vengono quindi replicati anche
 * come JSON in un secondo blocco di testo.
 */

export const textResult = (text, extra = {}) => ({
  content: [{ type: "text", text }],
  ...extra,
});

/** Riassunto leggibile + dati (in structuredContent e come JSON testuale). */
export const dataResult = (summary, data, extra = {}) => ({
  content: [
    { type: "text", text: summary },
    { type: "text", text: JSON.stringify(data) },
  ],
  structuredContent: data,
  ...extra,
});
